import React from "react";
import useStyles from "../../styles";
import CheckIcon from '../../assets/bttn_radio.svg';
import WarningIcon from '../../assets/icn_info_red.svg';
import CheckIconYellow from '../../assets/bttn_radio_yellow.svg';


const WarningExpanded = ({sentences}) => {
    const cl = useStyles();

    return (<div className={cl.warningExpanded}>
        {sentences.map((item, idx) => {
            let picture;

            switch (item.color) {
                case 'red':
                    picture = WarningIcon;
                    break;
                case 'yellow':
                    picture = CheckIconYellow;
                    break;
                default:
                    picture = CheckIcon;
            }

            return (<div className={cl.warningExpandedWrapper} key={item.text + idx}>
                <img src={picture} alt="Icon." className={cl.warningExpandedIcon}/>
                <p
                    //className={item.color ? cl.warningExpandedText : cl.warningExpandedTextGreen}
                    className={cl.warningExpandedTextGreen}
                >
                    {item.text && item.text}
                </p>
            </div>)
        })}
    </div>);
}

export default WarningExpanded;
